//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Loaded after mount: the lightbox itself is only shown on click.
const VueEasyLightbox = () => import('vue-easy-lightbox')

export default {
  name: 'LightBox',
  props: {
    source: {
      type: Array,
    },
  },
  components: {
    VueEasyLightbox,
  },
  data() {
    return {
      visible: false,
      img: [],
      idx: 0,
    }
  },
  methods: {
    showImg(idx) {
      this.idx = idx
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
  },
}
